import { ErrorMessageContents } from '../../../helpers/hub'
import { Venue } from './types'

export const venueFetch = () => ({ type: 'venue.fetch' } as const)
export type VenueFetchAction = ReturnType<typeof venueFetch>

export const addVenues = (queueStats: Venue[]) =>
  ({ type: 'venue.addVenue', payload: queueStats } as const)
export type AddVenuesAction = ReturnType<typeof addVenues>

export const venueFetchFail = (error: ErrorMessageContents) =>
  ({ type: 'venue.fetchFail', payload: error, error: true } as const)
export type VenueFetchFailAction = ReturnType<typeof venueFetchFail>

export type VenueAction =
  | VenueFetchAction
  | AddVenuesAction
  | VenueFetchFailAction
